import { createContext, useContext } from 'react'

export interface NavContextType {
  isMainNavCollapsed: boolean
  setIsMainNavCollapsed: (collapsed: boolean) => void
  toggleMainNav: () => void
  mainNavWidth: number

  hasNestedSidebar: boolean
  setHasNestedSidebar: (hasContent: boolean) => void
  isNestedSidebarOpen: boolean
  setIsNestedSidebarOpen: (isOpen: boolean) => void
  toggleNestedSidebar: () => void

  portalContainer: HTMLDivElement | null
  setPortalContainer: (element: HTMLDivElement | null) => void
}

export const NavContext = createContext<NavContextType | undefined>(undefined)

export const EXPANDED_NAV_WIDTH = 200
export const COLLAPSED_NAV_WIDTH = 48

const noop = (): void => {}

const defaultNavContext: NavContextType = {
  isMainNavCollapsed: false,
  setIsMainNavCollapsed: noop,
  toggleMainNav: noop,
  mainNavWidth: EXPANDED_NAV_WIDTH,
  hasNestedSidebar: false,
  setHasNestedSidebar: noop,
  isNestedSidebarOpen: false,
  setIsNestedSidebarOpen: noop,
  toggleNestedSidebar: noop,
  portalContainer: null,
  setPortalContainer: noop,
}

export const useNav = (): NavContextType => {
  const context = useContext(NavContext)
  return context ?? defaultNavContext
}
